import React from "react";
import DefaultLayout from "./admin/layout/DefaultLayout";
import { useTranslation, TranslationKey } from "./i18n/hooks";

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800">{t('notFound.title' as any as TranslationKey)}</h1>
        <p className="text-2xl text-gray-600 mt-4">{t('notFound.heading' as any as TranslationKey)}</p>
        <p className="text-gray-500 mt-2">
          {t('notFound.description' as any as TranslationKey)}
        </p>
        <a
          href="/admin/dashboard"
          className="mt-6 inline-block px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700"
        >
         {t('notFound.back_to_dashboard' as any as TranslationKey)}
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
